// What the desktop's IPC bridge could do and Paige cannot yet. The adapter answers an unknown
// method with undefined so the ported screen still comes up (desktop-adapter.ts); for a method that
// was supposed to CHANGE something that is a lie — the screen reports the change it never made and
// removes the thing from its own list. Those methods are named here and reject instead, so the
// screen shows the operator what happened and puts nothing back that is not there.

/** Desktop methods that change something Paige does not carry; the message the operator reads. */
const refusals: Readonly<Record<string, string>> = {
  // The workbench's own Delete sent the workspace job id and the typed name to the engine; Paige
  // deletes a job from its card on the jobs home (DELETE /v1/jobs/{id}), where the ledger rows,
  // the stored files and the engine's copy go together. From here it would leave Paige's row behind.
  deleteJob:
    'Paige does not delete a job from here. An admin deletes it from its card on the jobs home, in the card menu, and Paige asks before it does.',
  // The desktop paused the worker on the operator's PC. Paige's jobs are not switched on and off
  // (Dustin, 2026-09-24: a job has a processing mode, never an on/off switch, and the board has no
  // switch), so the adapter reports every job ready and the Pause control never renders; this is
  // the answer if anything reaches for it anyway. Unbound, `next.jobId` on `undefined` was a
  // TypeError inside the error handler itself. (Its earlier words sent the person to a Pause on the
  // job's Paige page, which the board no longer has.)
  setJobProcessingPaused:
    'Paige does not pause a job. Its processing mode in Job setup (Manual or Autopilot, on Review thresholds) decides what waits for a person.',
  // PORT.md row 1 classifies CapturePoint's engine-side job counts desktop-only: Paige answers
  // them from the ledger (JobCards.cs), in the tenant's own time zone. Asking the engine too
  // would put two sources of truth behind one card. The caller logs and leaves the counts blank.
  getJobWorkSummary:
    "Paige counts a job's work in the account, not in the engine, so this screen does not ask the engine for it.",
};

/** The refusal for a method Paige does not carry, or null when the method may answer with nothing. */
export function refusalFor(method: string): string | null {
  return Object.hasOwn(refusals, method) ? (refusals[method] as string) : null;
}

/** The methods that reject, for the catalogue and the tests. */
export const notCarried: readonly string[] = Object.keys(refusals);
